import styled, { css } from 'styled-components'
import { desktopBreakpoint, mobileBreakpoint, tabletBreakpoint } from 'react-components'
import DynamicMarkdown from '../../app-components/dynamic-components/dynamic-markdown'

export const Container = styled.section(
    ({ theme }) => css`
        padding: ${theme.spacing.medium} ${theme.spacing.large};
        display: flex;
        margin-top: ${theme.spacing.xLarge};

        @media only screen and (max-width: ${tabletBreakpoint.max}px) {
            flex-direction: column;
        }

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
        }
    `,
)

export const TitleSubtitleWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.xxSmall};
        margin-bottom: ${theme.spacing.medium};
        padding: ${theme.spacing.small} 0 ${theme.spacing.xxSmall};
        max-width: 17.625rem;

        @media only screen and (max-width: ${tabletBreakpoint.max}px) {
            max-width: none;
        }

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            padding: ${theme.spacing.medium} 0 0;
            margin-bottom: 0;
        }
    `,
)

export const TitleContainer = styled.h2(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 600;
        font-size: 1.5625rem;
        line-height: 1.875rem;
        color: ${theme.colors.tfwBlack99};
    `,
)

export const SubtitleContainer = styled.p(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: ${theme.typography.font.size.medium};
        font-weight: 400;
        line-height: 1.5rem;
        color: #5f5f5f;
    `,
)
export const ContentWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const FAQItem = styled.div(
    ({ theme }) => css`
        display: flex;
        padding: ${theme.spacing.large} 0;
        gap: ${theme.spacing.large};
        border-bottom: 0.0625rem dotted #d3d3d3;
        text-decoration: none;
        color: inherit;

        &:first-child {
            padding-top: ${theme.spacing.medium};
        }

        &:last-child {
            padding-bottom: ${theme.spacing.medium};
            border-bottom: none;
        }

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            flex-direction: column;
            gap: ${theme.spacing.xSmall};
        }
    `,
)

export const Question = styled.h3(
    ({ theme }) => css`
        display: flex;
        width: 23.9375rem;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-weight: 600;
        font-size: ${theme.typography.font.size.large};
        color: ${theme.colors.tfwBlack99};
        line-height: 1.75rem;

        @media only screen and (max-width: ${desktopBreakpoint.min}px) {
            width: auto;
            max-width: 16.25rem;
        }

        @media only screen and (max-width: ${mobileBreakpoint.max}px) {
            width: auto;
            max-width: none;
        }
    `,
)

export const Answer = styled.p(
    ({ theme }) => css`
        display: flex;
        flex: 1;
        font-family: ${theme.typography.font.family.latoVerdana};
        font-size: ${theme.typography.font.size.medium};
        font-weight: 400;
        color: ${theme.colors.tfwBlack99};
        line-height: ${theme.spacing.large};
    `,
)

export const CustomMarkdown = styled(DynamicMarkdown)(
    ({ theme }) => css`
        & ul,
        li {
            font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.medium} / 1.5rem
                ${theme.typography.font.family.latoVerdana};
            color: ${theme.colors.tfwBlack99};
            margin: ${theme.spacing.small} ${theme.spacing.medium};
            padding: 0;
        }

        & p,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.medium} / 1.5rem
                ${theme.typography.font.family.latoVerdana};
            color: ${theme.colors.tfwBlack99};
            margin: ${theme.spacing.medium} 0;
            padding: 0;
        }

        & strong {
            color: #4a4a4a;
        }

        & p:first-child {
            margin-top: 0;
        }

        & p:last-child {
            margin-bottom: 0;
        }

        & a {
            color: #016bd4;
            text-decoration: none;

            &:hover {
                color: #0159b8;
                text-decoration: underline;
            }
        }
    `,
)
